// extracted by mini-css-extract-plugin
export var content = "_2r-3";
export var contentWrapper = "_2r-2";
export var fullWidthButton = "_2r-4";
export var heroImage = "_2r-6";
export var logo = "_2r-1";
export var logoContainer = "_2r-0";
export var panel = "_2r-5";